module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/result/photo02-1afc22cd0a38a3962f561da2903800b3.png";